/*
  TTS back-in-stock form - see snippets/tts-back-in-stock.liquid.
  Posts to Klaviyo's client API (public company id, no secret key):
  POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=<id>
  Success = HTTP 202 with an empty body.
*/
(function () {
  if (customElements.get('tts-back-in-stock')) return;

  var KLAVIYO_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';
  var STORAGE_KEY = 'tts-bis-subscribed';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function readSubscribed() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function rememberSubscribed(variantId) {
    try {
      var list = readSubscribed().filter(function (id) {
        return id !== variantId;
      });
      list.push(variantId);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(-50)));
    } catch (e) {
      /* storage unavailable: nothing to remember */
    }
  }

  class TtsBackInStock extends HTMLElement {
    connectedCallback() {
      if (!this._initDone) {
        this._initDone = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.button = this.querySelector('button[type="submit"]');
        this.fields = this.querySelector('[data-bis-fields]');
        this.status = this.querySelector('[data-bis-status]');
        this.selectedWrap = this.querySelector('[data-bis-selected]');
        this.selectedTitle = this.querySelector('[data-bis-variant-title]');
        this.variants = this.readVariants();
        this.variantId = String(this.dataset.variantId || '');
        this.busy = false;

        this.onSubmit = this.onSubmit.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);

        this.form.addEventListener('submit', this.onSubmit);
        this.input.addEventListener('input', this.onInput);
        /* Keep our own input events inside the element. */
        this.form.addEventListener('change', function (event) {
          event.stopPropagation();
        });
      }

      this.productInfo = this.closest('product-info');

      /* 1) Theme pubsub event, published after the section re-render (assets/product-variants.js). */
      if (typeof subscribe === 'function') {
        var eventName = typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange
          ? PUB_SUB_EVENTS.variantChange
          : 'variant-change';
        this.unsubscribe = subscribe(eventName, this.onVariantChange);
      }

      /* 2) Fallback: the product form's hidden id input fires "change" on every variant update. */
      if (this.productInfo) {
        this.productInfo.addEventListener('change', this.onFormChange);
      }

      var current = this.variants[this.variantId];
      this.update(
        this.variantId,
        current ? current.available : this.hidden,
        current ? current.title : null
      );
    }

    disconnectedCallback() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      if (this.productInfo) {
        this.productInfo.removeEventListener('change', this.onFormChange);
        /* Do not leave the add-to-cart row hidden if this element goes away. */
        this.productInfo.classList.remove('tts-bis-active');
        this.productInfo = null;
      }
    }

    readVariants() {
      var node = this.querySelector('[data-bis-variants]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent) || {};
      } catch (e) {
        return {};
      }
    }

    onVariantChange(payload) {
      var data = payload && payload.data;
      if (!data || !data.variant) return;
      if (this.productInfo && data.sectionId && this.productInfo.dataset.section &&
          data.sectionId !== this.productInfo.dataset.section &&
          data.sectionId !== this.productInfo.dataset.originalSection) {
        return;
      }
      this.update(String(data.variant.id), !!data.variant.available, data.variant.title);
    }

    onFormChange(event) {
      var target = event.target;
      if (!target || target.name !== 'id' || !target.form || this.contains(target)) return;
      /* getAttribute: form.id would return the input named "id" (named-element shadowing). */
      if (!/^product-form-/.test(target.form.getAttribute('id') || '')) return;
      var id = String(target.value || '');
      if (!id) {
        /* Combination does not exist: no subscription possible. */
        this.update('', true, null);
        return;
      }
      var known = this.variants[id];
      if (known) this.update(id, known.available, known.title);
    }

    onInput() {
      if (this.status.classList.contains('is-error')) {
        this.setError(false);
        this.setStatus('', '');
      }
    }

    update(variantId, available, title) {
      var changed = variantId !== this.variantId;
      this.variantId = variantId;
      this.dataset.variantId = variantId;

      var show = !!variantId && !available;
      this.hidden = !show;
      if (this.productInfo) this.productInfo.classList.toggle('tts-bis-active', show);

      if (this.selectedTitle) {
        var label = title && title !== 'Default Title' ? title : '';
        this.selectedTitle.textContent = label;
        this.selectedWrap.classList.toggle('hidden', !label);
      }

      if (!show) return;

      if (readSubscribed().indexOf(variantId) !== -1) {
        this.showSuccess(false);
      } else if (changed || this.fields.hidden) {
        this.resetForm();
      }
    }

    resetForm() {
      this.fields.hidden = false;
      this.setError(false);
      this.setStatus('', '');
      this.setBusy(false);
    }

    showSuccess(moveFocus) {
      this.fields.hidden = true;
      this.setError(false);
      this.setStatus(this.dataset.msgSuccess, 'is-success');
      if (moveFocus) {
        this.status.setAttribute('tabindex', '-1');
        this.status.focus({ preventScroll: true });
      }
    }

    setStatus(message, className) {
      this.status.classList.remove('is-error', 'is-success');
      if (className) this.status.classList.add(className);
      this.status.textContent = message || '';
    }

    setError(on) {
      var wrapper = this.input.closest('.field');
      if (wrapper) wrapper.classList.toggle('has-error', on);
      if (on) {
        this.input.setAttribute('aria-invalid', 'true');
      } else {
        this.input.removeAttribute('aria-invalid');
      }
    }

    setBusy(on) {
      this.busy = on;
      this.button.disabled = on;
      this.form.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.busy) return;

      var email = (this.input.value || '').trim();
      var variantId = this.variantId;

      if (!EMAIL_RE.test(email)) {
        this.setError(true);
        this.setStatus(this.dataset.msgErrorEmail, 'is-error');
        this.input.focus();
        return;
      }
      if (!variantId || !this.dataset.companyId) {
        this.setStatus(this.dataset.msgErrorGeneric, 'is-error');
        return;
      }

      this.setError(false);
      this.setBusy(true);
      this.setStatus(this.dataset.msgSending, '');

      var body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      var self = this;
      fetch(KLAVIYO_URL + '?company_id=' + encodeURIComponent(this.dataset.companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (response.ok) {
            rememberSubscribed(variantId);
            /* Tell Klaviyo the shopper's language, so the back-in-stock e-mail comes in HU / RO / EN. */
            try {
              var lang = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'hu').slice(0, 2);
              fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(self.dataset.companyId), {
                method: 'POST',
                headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
                body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: { locale: lang } } } })
              }).catch(function () {});
            } catch (e) {
              /* language is optional */
            }
            self.setBusy(false);
            /* The shopper may have switched size while the request ran. */
            if (self.variantId === variantId) self.showSuccess(true);
            return;
          }
          return response.text().then(function (text) {
            var emailProblem = false;
            try {
              var json = JSON.parse(text);
              emailProblem = (json.errors || []).some(function (err) {
                var pointer = (err.source && err.source.pointer) || '';
                return /email/i.test(pointer) || /email/i.test(err.detail || '');
              });
            } catch (e) {
              /* non-JSON error body */
            }
            self.setBusy(false);
            if (emailProblem) {
              self.setError(true);
              self.setStatus(self.dataset.msgErrorEmail, 'is-error');
              self.input.focus();
            } else {
              self.setStatus(self.dataset.msgErrorGeneric, 'is-error');
            }
          });
        })
        .catch(function () {
          self.setBusy(false);
          self.setStatus(self.dataset.msgErrorGeneric, 'is-error');
        });
    }
  }

  customElements.define('tts-back-in-stock', TtsBackInStock);
})();
